import {
  OPEN_CREDENTIAL_DIALOG,
  CLOSE_CREDENTIAL_DIALOG,
  SET_IS_LOADING_CREDENTIALS,
  SET_CREDENTIAL_DIALOG_MODE,
  SET_DELETE_CREDENTIAL_DIALOG_OPEN,
  SET_CREDENTIAL_MANAGEMENT_FILTER,
  SET_CREDENTIAL_MANAGEMENT_SHARE_USERS_MODAL_OPEN,
  SET_CREDENTIAL_MANAGEMENT_UNSHARE_USERS_MODAL_OPEN,
  SET_CREDENTIAL_MANAGEMENT_SHARE_AVAILABLE_USERS,
  SET_CREDENTIAL_MANAGEMENT_UNSHARE_AVAILABLE_USERS,
  SET_CREDENTIAL_MANAGEMENT_SHARE_SELECTED_USERS,
  SET_CREDENTIAL_MANAGEMENT_UNSHARE_SELECTED_USERS,
  SET_SELECTED_CREDENTIAL,
  CLEAR_CREDENTIALS_MANAGEMENT_SHARE_SELECTED_USERS,
  ADD_CREDENTIALS_MANAGEMENT_SHARE_SELECTED_USER,
  REMOVE_CREDENTIALS_MANAGEMENT_SHARE_SELECTED_USER,
  SET_CREDENTIALS
} from "redux/constants/portal";

const initialState = {
  isCredentialDialogOpen: false,
  isLoadingCredentials: false,
  credentialDialogMode: "add",
  isDeleteCredentialDialogOpen: false,
  credentialManagementFilter: "",
  credentialManagementShareUsersModalOpen: false,
  credentialManagementUnshareUsersModalOpen: false,
  credentialManangementShareAvailableUsers: [],
  credentialManagementUnshareAvailableUsers: [],
  credentialManangementShareSelectedUsers: [],
  credentialManagementUnshareSelectedUsers: [],
  selectedCredential: {},
  credentials: []
};

const credentialManagement = (state = initialState, { type, payload }) => {
  switch (type) {
    case OPEN_CREDENTIAL_DIALOG:
      return {
        ...state,
        isCredentialDialogOpen: true
      };
    case CLOSE_CREDENTIAL_DIALOG:
      return {
        ...state,
        isCredentialDialogOpen: false
      };
    case SET_IS_LOADING_CREDENTIALS:
      return {
        ...state,
        isLoadingCredentials: payload
      };
    case SET_CREDENTIAL_DIALOG_MODE:
      return {
        ...state,
        credentialDialogMode: payload
      };
    case SET_DELETE_CREDENTIAL_DIALOG_OPEN:
      return {
        ...state,
        isDeleteCredentialDialogOpen: payload
      };
    case SET_CREDENTIAL_MANAGEMENT_FILTER:
      return {
        ...state,
        credentialManagementFilter: payload
      };
    case SET_CREDENTIAL_MANAGEMENT_SHARE_USERS_MODAL_OPEN:
      return {
        ...state,
        credentialManagementShareUsersModalOpen: payload
      };
    case SET_CREDENTIAL_MANAGEMENT_UNSHARE_USERS_MODAL_OPEN:
      return {
        ...state,
        credentialManagementUnshareUsersModalOpen: payload
      };
    case SET_CREDENTIAL_MANAGEMENT_SHARE_AVAILABLE_USERS:
      return {
        ...state,
        credentialManangementShareAvailableUsers: payload
      };
    case SET_CREDENTIAL_MANAGEMENT_UNSHARE_AVAILABLE_USERS:
      return {
        ...state,
        credentialManagementUnshareAvailableUsers: payload
      };
    case SET_CREDENTIAL_MANAGEMENT_SHARE_SELECTED_USERS:
      return {
        ...state,
        credentialManangementShareSelectedUsers: payload
      };
    case CLEAR_CREDENTIALS_MANAGEMENT_SHARE_SELECTED_USERS:
      return {
        ...state,
        credentialManangementShareSelectedUsers: []
      };
    case ADD_CREDENTIALS_MANAGEMENT_SHARE_SELECTED_USER:
      return {
        ...state,
        credentialManangementShareSelectedUsers: [
          ...state.credentialManangementShareSelectedUsers,
          payload
        ]
      };
    case REMOVE_CREDENTIALS_MANAGEMENT_SHARE_SELECTED_USER:
      return {
        ...state,
        credentialManangementShareSelectedUsers:
          state.credentialManangementShareSelectedUsers.filter((user) => user.user_id !== payload)
      };
    case SET_CREDENTIAL_MANAGEMENT_UNSHARE_SELECTED_USERS:
      return {
        ...state,
        credentialManagementUnshareSelectedUsers: payload
      };
    case SET_SELECTED_CREDENTIAL:
      return {
        ...state,
        selectedCredential: payload
      };
    case SET_CREDENTIALS:
      return {
        ...state,
        credentials: payload
      };
  }
  return state;
};

export default credentialManagement;
